/* PW v94.9 (15 Oct). Loaded sitewide from sections/pw-v949.liquid, does work only where its targets exist.
   1. Homepage hero: compact rating line under the CTAs (window.PW949R from the shop's Judge.me metafields).
   2. Funny Corner "Open Mic" stage (see funny() below), Rusty out of it for now.
   Motion is CSS; prefers-reduced-motion turns it off there. */
(function () {
  function heroTrust() {
    var r = window.PW949R, ctas = document.querySelector('.ns-hero__ctas');
    if (!r || !ctas || !(r.n > 0) || document.querySelector('.pw949-trust')) return;
    var a = document.createElement('a');
    a.className = 'pw949-trust';
    a.href = r.href || '#pw949-quotes';
    a.innerHTML = '<span class="pw949-trust__s" aria-hidden="true">&#9733;</span> <b></b> from <span class="pw949-trust__n"></span> reviews';
    a.querySelector('b').textContent = r.r;
    a.querySelector('.pw949-trust__n').textContent = r.n;
    a.setAttribute('aria-label', 'Rated ' + r.r + ' out of 5 from ' + r.n + ' reviews. Read them');
    ctas.insertAdjacentElement('afterend', a);
  }

  /* Funny Corner "Open Mic" (Che's pick, 16 Oct): a navy comedy-club stage. Velvet curtains with a swag valance,
     a warm spotlight landing on a wooden stage floor, a chasing marquee-bulb sign, a mic stand, the products as the
     acts, staff notes as ticket stubs and a slow headline crawl. Styles: assets/pw-949e.css. */
  function funny() {
    var sec = document.querySelector('.ns-funny');
    if (!sec || sec.dataset.pw949) return;
    sec.dataset.pw949 = '1';
    sec.classList.add('pw949-fc', 'pw949-fc--a');

    function el(cls) { var d = document.createElement('div'); d.className = cls; d.setAttribute('aria-hidden', 'true'); return d; }

    /* Rusty is out of this section for now; the old corner art becomes an empty slot */
    var r = sec.querySelector('.ns-laugh');
    if (r) {
      r.parentNode.insertBefore(document.createComment(' PW peek slot: future Rusty side-peek. He slides in from the right edge with floppy ears, then slides back out. Empty for now. '), r);
      var slot = document.createElement('span');
      slot.className = 'pw949-peekslot'; slot.hidden = true; slot.setAttribute('aria-hidden', 'true');
      r.parentNode.replaceChild(slot, r);
    }

    /* stage set: haze and spotlight, floor, curtains with two fold layers each, valance */
    sec.insertBefore(el('pw949-spot'), sec.firstChild);
    sec.appendChild(el('pw949-floor'));
    ['l', 'r'].forEach(function (side) {
      var c = el('pw949-curtain pw949-curtain--' + side);
      c.appendChild(el('pw949-fold pw949-fold--1')); c.appendChild(el('pw949-fold pw949-fold--2'));
      sec.appendChild(c);
    });
    sec.appendChild(el('pw949-valance'));

    /* center stage: reserved for a future Rusty-at-the-mic animation (standing on stage, holding the mic). Empty for now. */
    sec.appendChild(document.createComment(' PW center-stage slot: future Rusty at the mic, standing on stage holding the mic. Hidden and empty for now. '));
    var stage = document.createElement('span');
    stage.className = 'pw949-stageslot'; stage.hidden = true; stage.setAttribute('aria-hidden', 'true');
    sec.appendChild(stage);

    var head = sec.querySelector('.ns-head');
    var h2 = sec.querySelector('.ns-head h2');
    if (h2 && !h2.parentNode.classList.contains('pw949-marq')) {
      var m = document.createElement('div'); m.className = 'pw949-marq';
      h2.parentNode.insertBefore(m, h2); m.appendChild(h2);
    }
    if (head) {
      var mic = document.createElement('span'); mic.className = 'pw949-mic'; mic.setAttribute('aria-hidden', 'true');
      mic.innerHTML = '<svg viewBox="0 0 48 140" width="48" height="140"><g fill="#2B3266"><rect x="16" y="4" width="16" height="26" rx="8"/><rect x="22" y="30" width="4" height="96"/><rect x="21" y="38" width="20" height="3" rx="1.5" transform="rotate(-28 21 38)"/><path d="M6 136l18-12 18 12z"/></g><rect x="18" y="8" width="4" height="16" rx="2" fill="#4A5296"/></svg>';
      head.appendChild(mic);
    }

    /* the headline crawl between the copy and the acts */
    var lines = [].slice.call(sec.querySelectorAll('.ns-note__q')).map(function (t) { return t.textContent.trim(); }).filter(Boolean);
    if (head && !sec.querySelector('.pw949-crawl')) {
      var bar = el('pw949-crawl'), win = el('pw949-crawl__win'), run = el('pw949-crawl__run');
      var t = ['Tonight on stage: The Funny Corner', 'Staff notes, unedited', 'Legal asked', 'Two drink minimum (coffee)'].concat(lines).join('  ✦  ') + '  ✦  ';
      run.textContent = t + t; win.appendChild(run); bar.appendChild(win);
      head.insertAdjacentElement('afterend', bar);
    }
  }

  /* Product descriptions: a paragraph that is a bold label followed by <br> lines ("What you get", "The cap",
     "Good to know") becomes the label plus a real list, so it gets the gold bullets in assets/pw-949b.css. */
  function descLists() {
    [].forEach.call(document.querySelectorAll('.pw-pdp .pw-why__body p'), function (p) {
      if (p.dataset.pw949) return;
      p.dataset.pw949 = '1';
      var first = p.firstElementChild;
      if (!first || !/^(STRONG|B)$/.test(first.tagName) || p.firstChild !== first) return;
      if (p.querySelectorAll('br').length < 2) return;
      var parts = [], cur = document.createDocumentFragment(), seenLabel = false;
      [].slice.call(p.childNodes).forEach(function (n) {
        if (!seenLabel && n === first) { seenLabel = true; return; }
        if (n.nodeName === 'BR') { parts.push(cur); cur = document.createDocumentFragment(); return; }
        cur.appendChild(n.cloneNode(true));
      });
      parts.push(cur);
      parts = parts.filter(function (f) { return (f.textContent || '').trim(); });
      if (parts.length < 2) return;
      var lab = document.createElement('p');
      lab.className = 'pw949-dlabel';
      lab.appendChild(first.cloneNode(true));
      var ul = document.createElement('ul');
      parts.forEach(function (f) { var li = document.createElement('li'); li.appendChild(f); ul.appendChild(li); });
      p.parentNode.insertBefore(lab, p);
      p.parentNode.replaceChild(ul, p);
    });
  }

  function init() { heroTrust(); funny(); descLists(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
